import React, { useState } from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import PageHeader from '../components/PageHeader.jsx';

let Katie = 'https://static.igem.wiki/teams/5066/team/members/katie.png';
let Megan = 'https://static.igem.wiki/teams/5066/team/members/megan.png';
let Myron = 'https://static.igem.wiki/teams/5066/team/members/myron.png';
let Morris = 'https://static.igem.wiki/teams/5066/team/members/morris.png';
let Florence = 'https://static.igem.wiki/teams/5066/team/members/florence.png';
let Claire = 'https://static.igem.wiki/teams/5066/team/members/claire.png';
let Anabelle = 'https://static.igem.wiki/teams/5066/team/members/anabelle.png';
let Chelsea = 'https://static.igem.wiki/teams/5066/team/members/chelsea.png';
let Eugene = 'https://static.igem.wiki/teams/5066/team/members/eugene.png';
let Lucia = 'https://static.igem.wiki/teams/5066/team/members/lucia.png';
let Audrey = 'https://static.igem.wiki/teams/5066/team/members/audrey.png';
let Abby = 'https://static.igem.wiki/teams/5066/team/members/abby.png';
let Dora = 'https://static.igem.wiki/teams/5066/team/members/dora.png';
let Terrence = 'https://static.igem.wiki/teams/5066/team/members/terrence.png';
let Abner = 'https://static.igem.wiki/teams/5066/team/members/abner.png';
let Shaun = 'https://static.igem.wiki/teams/5066/team/members/shaun.png';
let Fannie = 'https://static.igem.wiki/teams/5066/team/members/fannie.png';
let Sophie = 'https://static.igem.wiki/teams/5066/team/members/sophie.png';

let Bryan = 'https://static.igem.wiki/teams/5066/team/members/bryan.png';
let Natasha = 'https://static.igem.wiki/teams/5066/team/members/natasha.png';
let Kris = 'https://static.igem.wiki/teams/5066/team/members/kris.png';
let Roger = 'https://static.igem.wiki/teams/5066/team/members/roger.png';
let Justin = 'https://static.igem.wiki/teams/5066/team/members/justin.png';
let Carolyn = 'https://static.igem.wiki/teams/5066/team/members/carolyn.png';
let Coco = 'https://static.igem.wiki/teams/5066/team/members/coco.png';
let Alex = 'https://static.igem.wiki/teams/5066/team/members/alex.png';
let Jocelyn = 'https://static.igem.wiki/teams/5066/team/members/jocelyn.png';
let Mia = 'https://static.igem.wiki/teams/5066/team/members/mia.png';
let CrownIcon = 'https://static.igem.wiki/teams/5066/team/crown.png';
let CoverPic = 'https://static.igem.wiki/teams/5066/team/teamphoto.png';
let Wilson = 'https://static.igem.wiki/teams/5066/team/advisors/wilson.png';
let Deana = 'https://static.igem.wiki/teams/5066/team/advisors/deana.png';
let Daniel = 'https://static.igem.wiki/teams/5066/team/advisors/daniel-hsu.png';
let Luke = 'https://static.igem.wiki/teams/5066/team/advisors/luke.png';
let Shiuan = 'https://static.igem.wiki/teams/5066/team/instructor/shiuan.png';
let Timmy = 'https://static.igem.wiki/teams/5066/team/instructor/timmy.png';
let Jakie = 'https://static.igem.wiki/teams/5066/team/instructor/jakie.png';
let Jessie = 'https://static.igem.wiki/teams/5066/team/instructor/jessie.png';
let Gina = 'https://static.igem.wiki/teams/5066/team/instructor/gina.png';
let David = 'https://static.igem.wiki/teams/5066/team/instructor/david.png';
let MorrisH = 'https://static.igem.wiki/teams/5066/new/morris.jpeg';

const teamData = {
	'PROJECT LEADS': [
		{
			name: 'Katie Liu',
			roles: ['Project Lead', 'Wet Lab'],
			description:
				"Hi, I'm Katie and I'm a junior at Taipei American School. I like doing experiments in the lab and learning more about biology. In addition, I enjoy playing soccer and trying new kinds of food.",
			imageUrl: Katie,
		},
		{
			name: 'Carolyn Chen',
			roles: ['Project Lead', 'Wet Lab', 'Art'],
			description:
				"Wassup, I'm Carolyn. I'm a junior at Taipei American School. Half the time, I think about wanting to be a fish. I enjoy attempting to cook, hiking, crocheting, and writing questionable fanfictions.",
			imageUrl: Carolyn,
		},
		{
			name: 'Lucia Ting',
			roles: ['Project Lead', 'Wet Lab', 'Art'],
			description:
				"HI, I'm Lucia and I'm a senior at Taipei European School. I enjoy doing experiments in the lab and learning about science! Other than that, I love music, food, and baking, especially chocolate chip cookies!",
			imageUrl: Lucia,
		},
		{
			name: 'Megan Chiao',
			roles: ['Project Lead', 'Wet Lab'],
			description:
				"Hi I'm Megan and a senior at Taipei European School. I love working in labs or learning about the science behind things. On top of that, I'm a huge fish, nature enthusiast, I love diving and hiking in new countries! ",
			imageUrl: Megan,
		},
		{
			name: 'Anabelle Lin',
			roles: ['Project Lead', 'Software'],
			description:
				'My name is Anabelle, and I’m a junior at Taipei American School. I’m just your average robotics kid who somehow found her way into this iGEM team. Outside of biology and robotics, I also enjoy music. I’m looking forward to working with this team to accomplish great things!',
			imageUrl: Anabelle,
		},
	],

	'WET LAB': [
		{
			name: 'Myron Yu',
			roles: ['Lead', 'Wet Lab'],
			description:
				"Hi. I am Myron, and I'm a junior at Taipei American School. I enjoy going to the lab to experiment and to listen to my friends' favorite songs. I also like otters and eating food. I am really grateful and incredibly honored to be part of this year's GEMS iGEM team and to be able to learn from my instructors and my fellow wetlab people. ",
			imageUrl: Myron,
		},
		{
			name: 'Abby Hung',
			roles: ['Lead', 'Wet Lab'],
			description:
				"Hi!! I'm Abby a junior in Kang Chiao International School. Love science and experiments. Beside that, I love to cook and make cute cartoon bento boxes. ",
			imageUrl: Abby,
		},
		{
			name: 'Florence Wu',
			roles: ['Lead', 'Wet Lab'],
			description:
				"Hi!! I'm Florence and I'm a rising junior at TAS. I enjoy writing poems and volunteering at the public library near my home. iGEM has been a really defining experience for me this year so far and I hope to be able to find another experience like this in the future. Preach the Jamboree!",
			imageUrl: Florence,
		},
		{
			name: 'Morris Yang',
			roles: ['Lead', 'Wet Lab'],
			description:
				'Hello. I am Morris, a junior at KCIS. I love conducting experiments in the lab and learning more about science. Likewise, I enjoy reading manga and playing video games. iGEM is a special experience for me, and I love this team!',
			imageUrl: Morris,
		},
		{
			name: 'Chelsea Lin',
			roles: ['Wet Lab'],
			description:
				'Hello guys! I’m Chelsea and I’m a rising senior at Taipei Fuhsing Private School. Some of my hobbies are dancing, badminton, and basketball. I LOVE to dance and I guess it is the only way for me to get rid of my stress :)',
			imageUrl: Chelsea,
		},
		{
			name: 'Audrey Fang',
			roles: ['Wet Lab'],
			description:
				"Hiii! I'm Audrey! I am a senior at KCIS. Science aside, I have a strong passion for going to concerts, rating cringe pick up lines, and learning things in a neurological aspect!",
			imageUrl: Audrey,
		},
		{
			name: 'Eugene Lee',
			roles: ['Wet Lab'],
			description:
				"Helloo, I’m Eugene and I’m a senior at KCIS.I absolutely love animals, so I have a whole bunch of pets - from Axolotos and sturgeons to my Shiba Inu. Aside from caring for pets, I also enjoy fencing in my free time. It's a fun hobby that keeps me active and entertained!",
			imageUrl: Eugene,
		},
		{
			name: 'Dora Shen',
			roles: ['Wet Lab'],
			description:
				'Heyyy guys, I’m Dora, a senior at KCIS. I’m a HUGE nature lover, so pls take me with you if you’re heading to the beach <3! Also, I’m a very concerning night owl so don’t be surprised if you catch me wide awake at 3 AM!',
			imageUrl: Dora,
		},
		{
			name: 'Abner Tseng',
			roles: ['Wet Lab'],
			description:
				'Hello, I am Abner Tseng, a Senior at Taipei American School. Biology has been my interest since I was little, and I wish to explore its realms further. I love eating spicy food.',
			imageUrl: Abner,
		},
	],
	'DRY LAB': [
		{
			name: 'Coco Yeh',
			roles: ['Lead', 'Dry Lab'],
			description:
				"Hi, I'm Coco and I am a senior at TES. I love eating good food, sleeping and reading.",
			imageUrl: Coco,
		},
        {
			name: 'Mia Chen',
			roles: ['Vice Lead', 'Dry Lab'],
			description:
				"Hi, I'm Mia. I'm a junior at Taipei American School and I love traveling, eating good food, and all things stem!",
			imageUrl: Mia,
		},
		{
			name: 'Justin Wu',
			roles: ['Dry Lab'],
			description:
				"Hi, I'm Justin. I am a senior at Taipei American School. I enjoy playing basketball, eating good food, and learning new things. ",
			imageUrl: Justin,
		},
		{
			name: 'Alex Liao',
			roles: ['Dry Lab'],
			description:
				"Hi, I'm Alex. I am a senior at TES. I don't really enjoy anything but if I had to choose I would say I love math, basketball, running, and sleeping. ",
			imageUrl: Alex,
		},
		{
			name: 'Jocelyn Liao',
			roles: ['Dry Lab'],
			description:
				"Hi, I'm Jocelyn, a junior at Taipei American School. I love playing volleyball, painting, and trying new food!",
			imageUrl: Jocelyn,
		},
	],
	'HUMAN PRACTICES': [
		{
			name: 'Natasha Liu',
			roles: ['Lead', 'Human Practices'],
			description:
				'I’m Natasha and I’m going into junior year at TAS:D I love gaming, binge watching shows and talking to my friends! I’m excited to make new valuable memories and work to win the grand prize!  ',
			imageUrl: Natasha,
		},
		{
			name: 'Bryan Chen',
			roles: ['Lead', 'Human Practices'],
			description:
				"Greetings! I'm Bryan, hailing from the vibrant city of Taipei, Taiwan. As an adolescent currently engaged in secondary education, I possess a fervent zeal for the realm of synthetic biology, a passion ignited by the futuristic concepts depicted in Cyberpunk2077. Additionally, I hold an insatiable affection for bread!",
			imageUrl: Bryan,
		},
		{
			name: 'Fannie Cheng',
			roles: ['Lead', 'Human Practices'],
			description:
				"My name is Fannie and I am a junior at TAS. I love shopping, traveling, and eating. Something I enjoy is sharing and hearing different views or ideas from others. I believe that active participation in dialogue and listening can broaden our horizons to become better versions of ourselves. I know I don't look the friendliest sometimes, but I promise I'm just sleep-deprived because I love talking to people. ",
			imageUrl: Fannie,
		},
		{
			name: 'Sophie Tan',
			roles: ['Human Practices'],
			description:
				'heyyy friends!! my name is sophie and i’m a senior at TAS! My hobbies include singing + dancing, but i also love being a total real blonde and eating cake. I joined gemgems to make new friends and learn/explore more about my passion: synthetic biology! (ps i am def a sonny angel + jellycat girlie <3)',
			imageUrl: Sophie,
		},
		{
			name: 'Kris Chiu',
			roles: ['Human Practices'],
			description:
				'Hi. I’m Kris and I’m a junior at TAS. The reason I join iGEM is because I enjoy new and challenging experiences. I was also interested in synthetic biology and wanted to gain experience in the field of biology. Finally, I am looking forward to accomplishing great feats and gaining valuable experiences with this team. ',
			imageUrl: Kris,
		},
	],
	'SOFTWARE': [
		{
			name: 'Claire Chang',
			roles: ['Lead', 'Software'],
			description:
				"I'm Claire and I'm a 11th grader from Wego. I'm interested in coding and I love cute animals. Might be working 24/7 on coding...However, I'm  really excited to work as a team and achieve remarkable results!",
			imageUrl: Claire,
		},
		{
			name: 'Terrence Hsueh',
			roles: ['Vice Lead', 'Software'],
			description:
				"My name is Terrence, and I'm a 11th grader at KCIS. I wasn't interested in coding before joining this project, but I gradually developed an interest after studying and learning how to code. Apart from coding, I enjoy cycling and playing football. While there may be overnight coding sessions during the project, I'm enthusiastic about working as a team with my peers to achieve excellent results!",
			imageUrl: Terrence,
		},
		{
			name: 'Shaun Yu',
			roles: ['Vice Lead', 'Software'],
			description:
				"I'm Shaun, I'm in 11th grade from Kang Chiao International School. I'm not a coding guy, instead, I love animals. I love playing board games with my friends but am more about spending time with them. While exploring my interest I joined the software team for our iGEM team. I hope we have great cooperation during the project and achieve wonderful results! ",
			imageUrl: Shaun,
		},
	],
    'SUPPORTING': [
        {
			name: 'Roger Lee',
			roles: ['Dry Lab'],
			description: 'I am Roger.',
			imageUrl: Roger,
		},
    ]
};

const Team = () => {
	const tabs = Object.keys(teamData);
	const [activeTab, setActiveTab] = useState(tabs[0]);
	const [activeVerticalTab, setActiveVerticalTab] = useState(0);

	const handleHorizontalTabClick = (tab) => {
		setActiveTab(tab);
		setActiveVerticalTab(0);
	};

	const createRipple = (e) => {
		const button = e.currentTarget;
		const circle = document.createElement('span');
		const diameter = Math.max(button.clientWidth, button.clientHeight);
		const radius = diameter / 2;

		circle.style.width = circle.style.height = `${diameter}px`;
		circle.style.left = `${e.clientX - button.offsetLeft - radius}px`;
		circle.style.top = `${e.clientY - button.offsetTop - radius}px`;
		circle.classList.add('ripple');

		const ripple = button.getElementsByClassName('ripple')[0];

		if (ripple) {
			ripple.remove();
		}

		button.appendChild(circle);
	};

	const secondBoxTabs = ['INSTRUCTORS', 'ADVISORS'];
	const secondBoxData = {
		INSTRUCTORS: [
			{
				name: 'Shiuan',
				roles: ['Wetlab'],
				description:
					'Hi, I am Shiuan and I like to do research. I enjoy iGEM very much.',
				imageUrl: Shiuan,
			},
			{
				name: 'Timmy',
				roles: ['Drylab'],
				description:
					"Timmy here. I really enjoy doing research with young bright minds, but sometimes they really drive me crazy. In the years of navigating through iGEM, I've come to realize education can change a lot of things, like turning students into creative problem solvers, and also like turning fresh livers into whatevers.",
				imageUrl: Timmy,
			},
			{
				name: 'Jakie',
				roles: ['Lab'],
				description:
					"Hi, I'm Jakie. I am passionate about unraveling the mysteries of cellular mechanism! I enjoy iGEM so much.",
				imageUrl: Jakie,
			},
			{
				name: 'Jessie',
				roles: ['Lab'],
				description:
					'I am Jessie! My professions are Chemistry and Education. I love science and enjoy teaching science! Being a HP instructor allows me to inspire students on how we could put science project into practice and make great impact to the society. ',
				imageUrl: Jessie,
			},
			{
				name: 'Gina',
				roles: ['Lab'],
				description:
					"I’m Gina, and I'm very passionate about synthetic biology. I think science is like art, carrying it out from initial ideas. As a wetlab instructor, I teach experiments, write down protocols, and troubleshoot. ",
				imageUrl: Gina,
			},
			{
				name: 'David',
				roles: ['Lab'],
				description:
					'Hi, I am David and my profession is in chemical and biological engineering. It is glad to attend 2024 GEMS-Taiwan as an instructor. I enjoy exploring interdisciplinary research of synthetic biology in this iGEM project and I believe it is a valuable experience for everyone.',
				imageUrl: David,
			},
		],
		ADVISORS: [
            {
				name: 'Morris Huang',
				roles: ['Software'],
				description:
					"Good morning, I am Morris. I was teams 2022 'Fusarium Won't' member and 2023 Cure-All Reef advisor. I truly enjoy filming and editing videos, so I hope to guide this year's team into something special. Goodbye.",
				imageUrl: MorrisH,
			},
			{
				name: 'Deana Chang',
				roles: ['Wetlab'],
				description:
					"Hiii I'm 'Dory' Deana! I am a senior in Taipei European School. I was a part of Cure-All Reef in 2023. Last year was so fun, so I became an advisor this year and got to know new people! (P.S. wait for it… OUR AUTONOMOUS UNDERWATER VEHICLE!!!)",
				imageUrl: Deana,
			},
            {
				name: 'Luke Wu',
				roles: ['Drylab'],
				description:
					"Hi, I'm Luke. I'm a sophomore from NUK. I was in the 2021 Igem team working with our team wiki. This year as an advisor, after working with the team, I was confident that they'll do well in this years IGem.",
				imageUrl: Luke,
			},
            {
				name: 'Ｗilson Lu',
				roles: ['Software'],
				description:
					"Hello, I am Wilson, from the 2023 GEMS-Taiwan team doing the cure all reefs project. I had the time of my life working with the team and couldn't be more glad. Although I do admit I've made quite some foolish mistakes along my journey. This year, I decided to become an advisor of the 2024 GEMS-Taiwan team, to help guide the new members to not repeat the same mistakes that I have made.",
				imageUrl: Wilson,
			},
            {
				name: 'Daniel Hsu',
				roles: ['Drylab'],
				description:
					'Wassup! I am Daniel from 2023 iGEM project Cure-all Reefs. From last year, I realize how special it is to participate in an iGEM competition and met a lot of people who have gone through happy and hard times with me.',
				imageUrl: Daniel,
			},
		],
	};
	const [activeSecondTab, setActiveSecondTab] = useState(secondBoxTabs[0]);
	const [activeSecondVerticalTab, setActiveSecondVerticalTab] = useState(0);

	return (
		<div>
			<div id='film'></div>
			<PageHeader img={CoverPic} />
			<div className='min-h-screen flex flex-col items-center p-20 bg-gradient-to-b from-[#fffef0] via-[#fff7fe] to-[#d9eaf0]'>
				{/* First Box */}
				<div className='bg-white shadow-xl rounded-lg overflow-hidden w-full max-w-6xl p-8 mb-8'>
					{/* Horizontal Tabs */}
					<div className='flex justify-center space-x-4 bg-[#f9e1ee] p-4 rounded-t-lg'>
						{tabs.map((tab) => (
							<button
								key={tab}
								className={`px-6 py-3 font-semibold rounded-md ${
									activeTab === tab
										? 'bg-white text-[#a33a73] shadow-lg'
										: 'text-gray-500 hover:text-gray-700'
								}`}
								onClick={() => handleHorizontalTabClick(tab)}
							>
								{tab}
							</button>
						))}
					</div>

					<SwitchTransition>
						<CSSTransition
							key={activeTab}
							timeout={300}
							classNames='fade'
						>
							<div className='flex'>
								<div className='vertical-tabs flex flex-col p-4 border-r-2'>
									{teamData[activeTab]?.map((person, idx) => (
										<button
											key={idx}
											className={`mb-4 p-3 ${
												activeVerticalTab === idx
													? 'bg-[#f9e1ee]'
													: 'hover:bg-gray-200'
											}`}
											onClick={(e) => {
												setActiveVerticalTab(idx);
												createRipple(e);
											}}
										>
											{person.name}
										</button>
									))}
								</div>
								<div className='p-8 bg-gray-50 rounded-b-lg '>
									<SwitchTransition>
										<CSSTransition
											key={activeVerticalTab}
											timeout={300}
											classNames='fade'
										>
											<div
												className='flex'
												style={{
													width: '850px',
													height: '400px',
												}}
											>
												{teamData[activeTab] &&
													teamData[activeTab][
														activeVerticalTab
													] && (
														<>
															<div className='w-[45%] flex justify-center items-center'>
																<img
																	className='w-64 h-64 rounded-full object-cover border-solid border-2 border-[#a33a73]'
																	src={
																		teamData[
																			activeTab
																		][
																			activeVerticalTab
																		]
																			.imageUrl
																	}
																	alt={
																		teamData[
																			activeTab
																		][
																			activeVerticalTab
																		].name
																	}
																/>
															</div>
															<div className='w-[55%] p-8 pt-8 overflow-auto'>
																<div className='flex flex-col justify-center flex-grow'>
																	<h2 className='text-2xl font-bold mb-2 flex items-center'>
																		{[
																			'Katie Liu',
																			'Claire Chang',
																			'Megan Chiao',
																			'Carolyn Chen',
																			'Lucia Ting',
																			'Myron Yu',
																			'Abby Hung',
																			'Florence Wu',
																			'Morris Yang',
																			'Coco Yeh',
																			'Anabelle Lin',
																			'Natasha Liu',
																			'Bryan Chen',
																		].includes(
																			teamData[
																				activeTab
																			][
																				activeVerticalTab
																			]
																				.name
																		) && (
																			<img
																				src={
																					CrownIcon
																				}
																				alt='Crown'
																				className='w-6 h-6 mr-2'
																			/>
																		)}
																		{
																			teamData[
																				activeTab
																			][
																				activeVerticalTab
																			]
																				.name
																		}
																	</h2>

																	<div className='flex flex-wrap gap-2 mb-4'>
																		{teamData[
																			activeTab
																		][
																			activeVerticalTab
																		].roles.map(
																			(
																				role,
																				idx
																			) => (
																				<span
																					key={
																						idx
																					}
																					className={`px-3 py-1 rounded-lg text-xs font-semibold ${
																						role ===
																						'Lead'
																							? 'bg-yellow-500 text-black uppercase font-bold rounded-lg'
																							: role ===
																							  'Wet Lab'
																							? 'bg-gradient-to-r from-purple-500 to-yellow-500 text-white'
																							: role ===
																							  'Dry Lab'
																							? 'bg-gradient-to-r from-gray-500 to-blue-500 text-white'
																							: role ===
																							  'Human Practices'
																							? 'bg-gradient-to-r from-pink-500 to-yellow-500 text-white'
																							: role ===
																							  'Software'
																							? 'bg-gradient-to-r from-blue-500 to-pink-500 text-white'
																							: role ===
																							  'Cross Team Lead'
																							? 'bg-red-500 text-white uppercase font-bold rounded-lg'
																							: 'bg-green-500 text-white'
																					}`}
																				>
																					{role ===
																					'Lead'
																						? 'LEAD'
																						: role ===
																						  'Cross Team Lead'
																						? 'CROSS-TEAM LEAD'
																						: role}
																				</span>
																			)
																		)}
																	</div>

																	<p className='text-base text-gray-700 '>
																		{
																			teamData[
																				activeTab
																			][
																				activeVerticalTab
																			]
																				.description
																		}
																	</p>
																</div>
															</div>
														</>
													)}
											</div>
										</CSSTransition>
									</SwitchTransition>
								</div>
							</div>
						</CSSTransition>
					</SwitchTransition>
				</div>

				{/* Second Box */}
				<div className='bg-white shadow-xl rounded-lg overflow-hidden w-full max-w-6xl p-8'>
					<div className='flex justify-center space-x-4 bg-[#f0f4ff] p-4 rounded-t-lg'>
						{secondBoxTabs.map((tab) => (
							<button
								key={tab}
								className={`px-6 py-3 font-semibold rounded-md ${
									activeSecondTab === tab
										? 'bg-white text-[#3a73a3] shadow-lg'
										: 'text-gray-500 hover:text-gray-700'
								}`}
								onClick={() => setActiveSecondTab(tab)}
							>
								{tab}
							</button>
						))}
					</div>

					<SwitchTransition>
						<CSSTransition
							key={activeSecondTab}
							timeout={300}
							classNames='fade'
						>
							<div className='flex'>
								<div className='vertical-tabs flex flex-col p-4 border-r-2'>
									{secondBoxData[activeSecondTab]?.map(
										(person, idx) => (
											<button
												key={idx}
												className={`mb-4 p-3 ${
													activeSecondVerticalTab ===
													idx
														? 'bg-[#f0f4ff]'
														: 'hover:bg-gray-200'
												}`}
												onClick={() =>
													setActiveSecondVerticalTab(
														idx
													)
												}
											>
												{person.name}
											</button>
										)
									)}
								</div>
								<div
									className='p-8 bg-gray-50 rounded-b-lg'
									style={{ width: '902px', height: '504px' }}
								>
									<SwitchTransition>
										<CSSTransition
											key={activeSecondVerticalTab}
											timeout={300}
											classNames='fade'
										>
											<div className='flex'>
												{secondBoxData[
													activeSecondTab
												] &&
													secondBoxData[
														activeSecondTab
													][
														activeSecondVerticalTab
													] && (
														<>
															<div className='w-[40%] flex justify-center items-center'>
																<img
																	className='w-64 h-64 rounded-full object-cover border-solid border-2 border-[#3a73a3]'
																	src={
																		secondBoxData[
																			activeSecondTab
																		][
																			activeSecondVerticalTab
																		]
																			.imageUrl
																	}
																	alt={
																		secondBoxData[
																			activeSecondTab
																		][
																			activeSecondVerticalTab
																		].name
																	}
																/>
															</div>
															<div className='w-[60%] p-8 pt-8'>
																<h2 className='text-2xl font-bold mb-2'>
																	{
																		secondBoxData[
																			activeSecondTab
																		][
																			activeSecondVerticalTab
																		].name
																	}
																</h2>
																<p className='text-base text-gray-700 '>
																	{
																		secondBoxData[
																			activeSecondTab
																		][
																			activeSecondVerticalTab
																		]
																			.description
																	}
																</p>
															</div>
														</>
													)}
											</div>
										</CSSTransition>
									</SwitchTransition>
								</div>
							</div>
						</CSSTransition>
					</SwitchTransition>
				</div>
			</div>
		</div>
	);
};

export default Team;
